window.mmkt = window.mmkt || {};
window.mmkt.core = window.mmkt.core || {};
window.mmkt.config = window.mmkt.config || {};
window.mmkt.modules = window.mmkt.modules || {};
window.mmkt.modules.active = window.mmkt.modules.active || {};
$ = jQuery;